import "./App.scss";
import Routes from "./routes/Routes";
import { Provider } from "react-redux";
import configureStore from 'store/configureStore';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import BrandThemeProvider from "contexts/ThemeContext";

export const { store } = configureStore();
if (process.env.NODE_ENV === "prod") {
  console.log = () => { };
}

function App() {
  return (
    <div className="App">
        <BrandThemeProvider>
          <Provider store={store}>
            <Routes />
          </Provider>
        </BrandThemeProvider>
    </div >
  );
}

export default App;
